import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { howLongAgo } from '@fiverr-private/futile/lib/datetime';
import { FiverrContext } from '@fiverr-private/fiverr_context';
import { DEFAULT_LOCALE } from '@fiverr-private/fiverr_context/lib/constants';
import I18n from '@fiverr-private/fiverr_context/src/I18n';

import './style.scss';

const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];

const renderHoursAsDays = (hours) => hours < 24 ?
    <I18n k={'gig_page_perseus.seller_card.response_time_hours'} params={{count: hours}}/> :
    <I18n k={'gig_page_perseus.seller_card.response_time_days'} params={{count: Math.round(hours / 24)}}/>;

const showResponseTime = (responseTime) => responseTime && responseTime > 0;

const formatMemberSince = (memberSince) => {
    const memberSinceDate = new Date(memberSince * 1000);

    return `${monthNames[memberSinceDate.getMonth()]} ${memberSinceDate.getFullYear()}`;
};

const formatRecentDelivery = (recentDelivery, locale) => howLongAgo(
    recentDelivery,
    {prefix:'gig_page_perseus.general.how_long_ago.', locale}
);

const Stats = ({country, memberSince, responseTime, recentDelivery}) => {
    const { locale = DEFAULT_LOCALE } = useContext(FiverrContext);

    if (!country && !memberSince && !showResponseTime(responseTime) && !recentDelivery) {
        return null;
    }

    return (
        <ul className="user-stats">
            {country &&
                <li>
                    <I18n k={'gig_page_perseus.seller_card.from'}/>
                    <strong>{country}</strong>
                </li>
            }
            {memberSince > 0 &&
                <li>
                    <I18n k={'gig_page_perseus.seller_card.member_since'}/>
                    <strong>{formatMemberSince(memberSince)}</strong>
                </li>
            }
            {showResponseTime(responseTime) &&
                <li>
                    <I18n k={'gig_page_perseus.seller_card.response_time'}/>
                    <strong>{renderHoursAsDays(responseTime)}</strong>
                </li>
            }
            {recentDelivery > 0 &&
                <li>
                    <I18n k={'gig_page_perseus.seller_card.recent_delivery'}/>
                    <strong>{formatRecentDelivery(recentDelivery, locale)}</strong>
                </li>
            }
        </ul>
    );
};

Stats.propTypes = {
    country: PropTypes.string,
    memberSince: PropTypes.number,
    responseTime: PropTypes.number,
    recentDelivery: PropTypes.number

};

export default Stats;
